var NavigationModel = Backbone.Epoxy.Model.extend({

  defaults: {
    currentTab: ''
  },

  computeds: {
    inBookingTab: function() {
      return _.contains(['start-booking', 'single-store-search', 'booking', 'complete'],
        this.get('currentTab'));
    },
    inWaitListTab: function() {
      return _.contains(['start-wait-list', 'single-store-search', 'booking', 'complete'],
        this.get('currentTab'));
    },
    bookingTabTitle: function() {
      return bookedby.staticData.storeGroupSettings.useWaitingList ? 'Add to Wait List' : 'Book an Appointment';
    },
    inGiftCardTab: function() {
      return this.get('currentTab') == 'gift-cards';
    },
    inReviewsTab: function() {
      return this.get('currentTab') == 'reviews-page';
    },
    inServicesTab: function() {
      return this.get('currentTab') == 'store-services';
    },
    iProvidersTab: function() {
      return this.get('currentTab') == 'store-service-providers';
    },
    inAccountTab: function() {
      return _.contains(['profile', 'client-reviews', 'upcoming-appointments', 'waiting-list', 'wait-board', 'service-history', 'login'],
        this.get('currentTab'));
    }
  }

});

module.exports = NavigationModel;

